
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.066 0h13.868C17.071 0 18 .93 18 2.066v13.868C18 17.07 17.07 18 15.934 18H2.066A2.072 2.072 0 010 15.934V2.066A2.07 2.07 0 012.066 0zm9.852 4.158l1.867 1.869a.635.635 0 010 .895l-1.034 1.034-2.764-2.764 1.034-1.034a.637.637 0 01.896 0zm-4.25 8.877c-.748.232-1.496.462-2.245.695-1.76.543-1.75.905-1.271-.787l.756-2.666-.003-.003 4.559-4.56 2.764 2.765-4.556 4.558-.004-.002zM5.38 10.747l1.815 1.815c-.49.15-.983.302-1.475.456-1.155.354-1.149.593-.835-.519l.495-1.752z","fill":"#A0A0A0"}})])
          )
        }
      }
    